const R = require('ramda')

module.exports = R.pipe(
  require('./wholesale/installClient'),
  require('./lookup/installClient'),
)
